import React, { useEffect } from 'react';
import { Masonry } from '@mui/lab';
import { Box } from '@mui/material';
import { useIndexList } from 'pages/dictionaries/contexts/IndexListContext';
import { DictionaryIndex } from 'lib';
import { IndexView } from './IndexView';
import { EmptyStateContainer } from '../../../../components/empty-state-container/EmptyStateContainer';
import AddIcon from '@mui/icons-material/Add';
import { Fab } from '@biq/apex-ui';
import { indexViewStyles } from './indexView-helpers';
import { DictionaryEmptyStateIcon } from '../../../../assets';
import { DictionaryManagerIndexEditDrawer } from './DictionaryManagerIndexEditDrawer';

interface DictionaryManagerIndexListProps {
    setIsChangesUnsaved?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DictionaryManagerIndexList = ({
    setIsChangesUnsaved,
}: DictionaryManagerIndexListProps): React.JSX.Element => {
    const {
        addIndex,
        selectedIndex,
        indexes,
        setSelectedIndex,
        newAddedIndex,
        setNewAddedIndex,
    } = useIndexList();

    useEffect(() => {
        if (newAddedIndex) {
            setSelectedIndex(newAddedIndex.id);
            setNewAddedIndex(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newAddedIndex]);

    const handleAddIndex = (): void => {
        setIsChangesUnsaved?.(true);
        addIndex();
    };

    return (
        <Box>
            <Fab
                type='button'
                sx={indexViewStyles.addNewIndexButtonStyles}
                icon={<AddIcon />}
                color='secondary'
                label='index'
                onClick={handleAddIndex}
            />
            <Box sx={{ mt: 3 }}>
                {indexes?.length ? (
                    <Masonry columns={2} spacing={2}>
                        {React.Children.toArray(
                            indexes?.map((idx: DictionaryIndex) => {
                                return (
                                    <IndexView
                                        index={idx}
                                        setIsChangesUnsaved={
                                            setIsChangesUnsaved
                                        }
                                    />
                                );
                            })
                        )}
                    </Masonry>
                ) : (
                    <Box sx={indexViewStyles.emptyStateContainer}>
                        <EmptyStateContainer
                            emptyStateBodyMessage={
                                'Create indexes using the button in the top left of this panel.'
                            }
                            emptyStateIcon={DictionaryEmptyStateIcon}
                        />
                    </Box>
                )}
            </Box>
            {selectedIndex ? (
                <DictionaryManagerIndexEditDrawer
                    setIsChangesUnsaved={setIsChangesUnsaved}
                />
            ) : (
                <></>
            )}
        </Box>
    );
};
